"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { resolveVinteraTopNavigationContext } from "../../lib/ui/navigationContext";
import AuthenticatedAccountMenu from "./AuthenticatedAccountMenu";
import CustomerCartLink from "./CustomerCartLink";

export default function PublicAccessLinks() {
  const pathname = usePathname();
  const context = resolveVinteraTopNavigationContext(pathname);

  if (context === "customer_portal") {
    return (
      <>
      <CustomerCartLink href="/portal/cart" label="My Cart" />
      <AuthenticatedAccountMenu kind="customer" />
      </>
    );
  }

  if (context === "staff_workspace") {
    return <AuthenticatedAccountMenu kind="staff" />;
  }

  return (
    <>
      <Link
        href="/apply"
        className="inline-flex min-h-11 items-center transition hover:text-[var(--vintera-navy)]"
      >
        Apply
      </Link>
      <Link
        href="/login"
        className="inline-flex min-h-11 items-center rounded-md bg-[var(--vintera-navy)] px-3.5 py-2 text-white transition hover:bg-[var(--vintera-navy-hover)]"
      >
        Login
      </Link>
    </>
  );
}
